<template>
  <v-card>
    <v-row row wrap no-gutters>
      <v-col d-flex xs12 sm6 md1 class="pa-0 ma-1">
        <!--for adding new school or clear form-->
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              color="primary"
              center
              left
              absolute
              @click="clearForm"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>បញ្ចូលថ្មី</span>
        </v-tooltip>
      </v-col>
      <v-col xs12 sm6 md1 class="pa-0 ma-1">
        <!-- for getting data from STS it is enable for public school ASCF only -->
        <div v-if="uiCon.formType < 10">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                color="primary"
                center
                @click="loadSTSData"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-arrow-down-bold-hexagon-outline</v-icon>
              </v-btn>
            </template>
            <span>ទាញទិន្នន័យពីSTS</span>
          </v-tooltip>
        </div>
      </v-col>
      <v-col d-flex xs12 sm6 md3 pa-0>
        <v-select
          :items="academics"
          v-model="ac_code"
          hide-details
          label="ឆ្នាំសិក្សា៖"
          @keypress="onkeypress($event)"
          id="a_code"
        ></v-select>
      </v-col>
      <v-col d-flex xs12 sm6 md3 class="pa-0 ma-1 mt-0">
        <v-text-field
          label="កូដសាលា:"
          mask="##-##-##-##-###"
          v-model="sc_code"
          hide-details
          ref="schoolCode"
          outline
        ></v-text-field>
      </v-col>
      <v-col d-flex xs12 sm6 md3 class="pa-0 ma-1">
        <v-btn
          color="success"
          class="ttext"
          rounded
          right
          absolute
          @click="searchSchool"
          >ស្វែងរកសាលា</v-btn
        >
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data: function () {
    return {
      academics: this.$store.state.uiControl.academics,
      ac_code: this.$store.state.uiControl.academics[0].value,
      sc_code: "",
    };
  },
  watch: {
    sc_code: function (oldCode, newCode) {
      this.searchSchool();
    },
  },
  computed: {
    ...mapState({
      uiCon: (state) => state.uiControl,
    }),
  },
  methods: {
    ...mapActions({
      loadDefaultwins: "wins/loadDefaultWins",
      getWinsData: "wins/getWins",
    }),
    clearForm: function () {
      // 10-11-12-13 Private Pre, Pri, Sec, Compre
      // 16-17 Dis, Pro form
      if (this.uiCon.formType === 5) {
        this.$store.dispatch("pubascf/loadDefaultPubascfPre");
        //this.$store.dispatch("climate/loadDefaultClimate");
      } else if (this.uiCon.formType === 6) {
        this.$store.dispatch("pubascf/loadDefaultPubascfPri");
        //this.$store.dispatch("climate/loadDefaultClimate");
      } else if (this.uiCon.formType === 7) {
        this.$store.dispatch("pubascf/loadDefaultPubascfSec");
        //this.$store.dispatch("climate/loadDefaultClimate");
      } else if (this.uiCon.formType === 10) {
        this.$store.dispatch("privascf/loadDefaultPrivascfPre");
      } else if (this.uiCon.formType === 11) {
        this.$store.dispatch("privascf/loadDefaultPrivascfPri");
      } else if (this.uiCon.formType === 12) {
        this.$store.dispatch("privascf/loadDefaultPrivascfSec");
      } else if (this.uiCon.formType === 13) {
        this.$store.dispatch("compre/loadDefaultCompre");
      } else if (this.uiCon.formType === 16) {
        // District Form
        this.$store.dispatch("prodis/loadDefaultProDis");
      } else if (this.uiCon.formType === 17) {
        // Provicial Form
        this.$store.dispatch("prodis/loadDefaultProDis");
      } else if (this.uiCon.formType === 22) {
        this.loadDefaultwins();
      } else if (this.uiCon.formType === 28) {
        this.$store.dispatch("textbook/loadDefaultTextbookPri");
      } else if (this.uiCon.formType === 29) {
        this.$store.dispatch("textbook/loadDefaultTextbookSec");
      } else if (this.uiCon.formType === 34) {
        this.$store.dispatch("puqemispri/loadDefaultQEMISpri");
      } else if (this.uiCon.formType === 35) {
        this.$store.dispatch("puqemissec/loadDefaultQEMISsec");
      }
      this.sc_code = "";
      // this.sc_code.focus()
      this.$refs.schoolCode.focus();
      // console.log('in search bar: ' + this.uiCon.formType + ' Can Save: ' + this.uiCon.canSave)
    },
    searchSchool: function () {
      if (this.sc_code.length >= 11) {
        if (this.uiCon.formType === 5) {
          //get the ASCF data
          this.$store.dispatch("pubascf/getPubAscfPre", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
          //get the climate data
          this.$store.dispatch("climate/getClimate", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
        } else if (this.uiCon.formType === 6) {
          //get the ASCF data
          this.$store.dispatch("pubascf/getPubAscfPri", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
          //get the climate data
          this.$store.dispatch("climate/getClimate", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
        } else if (this.uiCon.formType === 7) {
          //get the ASCF data
          this.$store.dispatch("pubascf/getPubAscfSec", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
          //get the wins data
          /*
          this.$store.dispatch("wins/getWins", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
          */
          //get the climate data
          this.$store.dispatch("climate/getClimate", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
        } else if (this.uiCon.formType === 10) {
          this.$store.dispatch("privascf/getPrivAscfPre", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
        } else if (this.uiCon.formType === 11) {
          this.$store.dispatch("privascf/getPrivAscfPri", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
        } else if (this.uiCon.formType === 12) {
          this.$store.dispatch("privascf/getPrivAscfSec", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
        } else if (this.uiCon.formType === 13) {
          this.$store.dispatch("compre/getCompre", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
        } else if (this.uiCon.formType === 16) {
          // District Form, pd_code is 4 digits BUT MUST Enter ZERO after for working, pf is Zero
          this.$store.dispatch("prodis/getProDis", {
            acc_code: this.ac_code,
            pd_code: this.sc_code,
            ipf: 0,
          });
        } else if (this.uiCon.formType === 17) {
          // Provincial Form, pd_code is 2 digits BUT MUST Enter ZERO after for working, pf is One
          this.$store.dispatch("prodis/getProDis", {
            acc_code: this.ac_code,
            pd_code: this.sc_code,
            ipf: 1,
          });
        } else if (this.uiCon.formType === 22) {
          this.getWinsData({ acc_code: this.ac_code, sch_code: this.sc_code });
        } else if (this.uiCon.formType === 28) {
          this.$store.dispatch("textbook/getTextbookPri", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
        } else if (this.uiCon.formType === 29) {
          this.$store.dispatch("textbook/getTextbookSec", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
        } else if (this.uiCon.formType === 34) {
          this.$store.dispatch("puqemispri/getQEMISpri", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
        } else if (this.uiCon.formType === 35) {
          this.$store.dispatch("puqemissec/getQEMISsec", {
            acc_code: this.ac_code,
            sch_code: this.sc_code,
          });
        }
        let ct =
          this.academics[Math.abs(this.ac_code - this.academics[0].value)].text;
        let lt =
          this.academics[Math.abs(this.ac_code - this.academics[0].value - 1)]
            .text;
        let tc =
          this.academics[Math.abs(this.ac_code - this.academics[0].value)]
            .sts_code;
        let age_control =
          this.academics[Math.abs(this.ac_code - this.academics[0].value)]
            .age_form_control;
        this.$store.dispatch("uiControl/setAcademic", {
          cur_code: this.ac_code,
          sts_code: tc,
          age_form_control: age_control,
          cur_text: ct,
          lst_text: lt,
        });
      }
    },
    /* Function getting data from STS API*/
    loadSTSData: function () {
      let sts_acc_code = this.$store.state.uiControl.sts_acc_code;
      if (this.uiCon.formType === 5) {
        this.$store.dispatch("pubascf/loadSTSPre", {
          sts_code: sts_acc_code,
          sch_code: this.sc_code,
        });
      } else if (this.uiCon.formType === 6) {
        this.$store.dispatch("pubascf/loadSTSPri", {
          sts_code: sts_acc_code,
          sch_code: this.sc_code,
        });
      } else if (this.uiCon.formType === 7) {
        this.$store.dispatch("pubascf/loadSTSSec", {
          sts_code: sts_acc_code,
          sch_code: this.sc_code,
        });
      }
    },
    onkeypress: function (evt) {
      var charCode = evt.keyCode;
      if (charCode > 48 && charCode < 52) {
        this.ac_code = "8";
      }
    },
    mounted() {
      this.loadDefault();
      // this.getQEMISpri({acc_code: '9', school_code: '15010101001'})
    },
  },
};
</script>

<style scoped>
.ttext {
  font-family: "Siemreap";
  font-weight: bold;
  font-size: 12px;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.v-input {
  font-family: "Roboto";
  font-weight: bold;
  font-size: 12px;
}
</style>